import { useEffect, useState } from 'react'
import './MessageModal.scss'
import { Form } from 'react-bootstrap'
import { conversationsService } from '../../services/conversationsService'
import { toast } from 'react-toastify'
import { MESSAGE_TYPE } from '../../constants/config'

/**
 *
 * @param {string} type - Type of conversation - private, product or request
 * @param {number} userId - Id of user receiving the message
 * @param {Object} product - Product receiving the message
 * @param {string} companyName - The name of the company to display in the modal
 */
export default function MessageModal({
  type,
  userId,
  product,
  companyName,
  closeModal,
}) {
  const [message, setMessage] = useState('')

  const getPrivateConversation = async () => {
    const response = await conversationsService.privateConversation({
      userId,
    })

    if (response.isOk) {
      return response.data.id
    }

    return null
  }

  const getProductConversation = async () => {
    const response = await conversationsService.productConversation({
      productId: product.id,
    })

    if (response.isOk) {
      return response.data.id
    }

    return null
  }

  const sendMessage = async () => {
    let conversationId = null

    if (type === MESSAGE_TYPE.private) {
      conversationId = await getPrivateConversation()
    } else if (type === MESSAGE_TYPE.product && product?.id) {
      conversationId = await getProductConversation()
    }

    if (!conversationId) {
      return
    }

    const response = await conversationsService.sendMessage({
      conversationId,
      content: message,
    })
    if (response.isOk) {
      closeModal()
      toast.success('Poruka poslana!')
    } else {
      toast.error(response?.message)
    }
  }

  useEffect(() => {
    // Disable scroll when modal is visible
    document.body.classList.add('body-no-scroll')

    return () => {
      document.body.classList.remove('body-no-scroll')
    }
  }, [])

  return (
    <div id="message-modal">
      <div className="content">
        <h5>{`Poruka za ${companyName}`}</h5>
        {product && type === MESSAGE_TYPE.product ? (
          <h6>{product.title}</h6>
        ) : null}

        <Form.Control
          as="textarea"
          name="message"
          placeholder="Poruka..."
          value={message}
          onChange={e => setMessage(e.target.value)}
        />

        <div className="buttons-container">
          <button
            onClick={closeModal}
            type="button"
            className="btn btn-secondary">
            Odustani
          </button>

          <button
            onClick={sendMessage}
            type="button"
            className="btn btn-primary">
            Pošalji
          </button>
        </div>
      </div>
    </div>
  )
}
